import React from "react";
import { Tooltip, TooltipProps } from "@material-ui/core";
import PropTypes from "prop-types";
import useStyles from "./styles";

const CobeeTooltip = ({ placement = "top", ...rest }: TooltipProps) => {
  const classes = useStyles();
  return <Tooltip classes={classes} placement={placement} {...rest} />;
};

CobeeTooltip.propTypes = {
  placement: PropTypes.string,
};

CobeeTooltip.defaultProps = {
  placement: "top",
};

export default CobeeTooltip;
